import { render } from "./TablerIcon.vue?vue&type=template&id=6e95621c"
import script from "./TablerIcon.vue?vue&type=script&lang=js"
export * from "./TablerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__